/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useContext, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from "formik";
import Layout from 'components/Layout';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import Loader from 'components/Loader';
import SelectField from 'components/Form/SelectField';
import { Row, Col } from 'components/Grid';
import FileModal from 'components/FileModal';
import TagList2 from 'components/TagList2';
import DialogComponent from "components/Dialog";
import Colors from "constants/Colors";
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { Scrollbox, DialogCancel, DialogConfirm, DialogSelect, ButtonContent, PlaceHolder, TagInput } from './styles';
import StepNavigation from 'components/StepNavigation/index';
import RenderButtons from 'components/RenderButtons';
import HasPermission from 'components/HasPermission/index';
import {useHeaderNbi, useGetDocuments, useWordingModal, useGetEnablePolicy} from 'services/QuoteService';

export default function WordingRequest(props) {

    const [summary, setSummary] = useState({});
    const [file, setFile] = useState();
    const [attachments, setAttachments] = useState([]);
    const [isDisable, setIsDisable] = useState(true);

    const history = useHistory();
    const loading = useContext(GlobalLoaderContext);
    const authContext = useContext(GlobalAuthContext);
    const fitinsur = new FitinsurAPI();
    const mc = new MessageCenter();
    fitinsur.setAuthToken(authContext.token);

    const {
        data: useHeaderNbiData,
        loading: useHeaderNbiLoading,
        error: useHeaderNbiError,
        status: useHeaderNbiStatus,
        request: useHeaderNbiRequest,
      } = useHeaderNbi();

      const {
        data: useGetDocumentsData,
        loading: useGetDocumentsLoading,
        error: useGetDocumentsError,
        status: useGetDocumentsStatus,
        request: useGetDocumentsRequest,
      } = useGetDocuments(props.match.params.idOperation);

      const {
        data: useWordingModalData,
        loading: useWordingModalLoading,
        error: useWordingModalError,
        status: useWordingModalStatus,
        request: useWordingModalRequest,
      } = useWordingModal(props.match.params.idOperation);

      const {
        data: useGetEnablePolicyData,
        loading: useGetEnablePolicyLoading,
        error: useGetEnablePolicyError,
        status: useGetEnablePolicyStatus,
        request: useGetEnablePolicyRequest,
      } = useGetEnablePolicy(props.match.params.idOperation);

      useEffect(() => {
        if (useHeaderNbiLoading || useGetDocumentsLoading || useWordingModalLoading || useGetEnablePolicyLoading) {
          loading.start();
        } else {
          loading.stop();
        }
      }, [useHeaderNbiLoading, useGetDocumentsLoading, useWordingModalLoading, useGetEnablePolicyLoading]);


    //////////// Lost Dialog ///////////////// 
    const [lostDeal, setLostDeal] = useState({
        formated: [],
        array: [],
    });
    const [dialog, setDialog] = useState({
        visible: false,
        title: "",
        icon: "times-circle",
        args: null,
    });

    const requestLostDealList = () => {

        fitinsur.requestLostDealList()
            .then((response) => {
                return response.json();
            })
            .then((data) => {

                if (data.ret_value) {
                    const lista = [];
                    for (let index = 0; index < data.ret_value.length; index++) {
                        lista.push({ label: data.ret_value[index].ANSWER_OPTION_DESCRIPTION, value: data.ret_value[index].ID_ANSWER_OPTION })

                    }
                    setLostDeal({ formated: lista, array: data.ret_value });

                } else {
                    mc.error("fitGetLostReason - UNEXPECTED RETURNED DATA => " + JSON.stringify(data));
                    setLostDeal({ formated: [{ label: 'Error', value: '' }], array: [] });
                }


            })
            .catch((error) => {
                mc.error(`There was an error while fetching your data: ${requestLostDealList.name}\n` + error);
                console.error('fitGetLostReason - Error:', error);
                setLostDeal({ formated: [{ label: 'Error', value: '' }], array: [] });
            });
    }

    const HandleLostSubmit = (selectedID, array, argsContext) => {
        console.log(selectedID, array, argsContext);
        fitinsur.setAuthToken(authContext.token);
        fitinsur.updateQuoteEdit(props.match.params.idOperation, selectedID.reasons).then(x => x.json()).then(res => {
            if (res.ret_code != 200) {
                mc.error(res.ret_msg_details);
                return;
            }
            setDialog({ visible: false, title: null, icon: null, args: null });
            history.push('/list');
        })
    };

    const goToLoginPage = () => {
        history.push('/login');
    };

    function handleModal() {
        useWordingModalRequest().then(({data}) => {
                setFile(data);
            })
            .catch((error) => {
                mc.error(`There was an error while fetching your data: ${handleModal.name}\n` + error);
                console.error('fitPostFiles - Error:', error);
            });
    };

    function handleGetFiles() {
        useGetDocumentsRequest().then(({data: response}) => {
                const files = response.ret_value;
                let aux = [];

                files.forEach(file => {
                    let obj = {
                        dsTypeDocument: "Attachment",
                        nameDocument: file.nameDocument,
                        idTypeDocument: file.idTypeDocument,
                        nameFile: file.nameFile,
                        size: file.size,
                        type: file.type,
                        urlLink: file.urlLink,
                        idDocument: file.idDocument
                    };
                    aux.push(obj);
                });
                setAttachments(aux);
            })
            .catch((error) => {
                mc.error(`There was an error while fetching your data: ${handleGetFiles.name}\n` + error);
                console.error('fitPostFiles - Error:', error);
            });
    }

    function handleEnablePolicyPack() {
        useGetEnablePolicyRequest().then(({data: resp}) => {
                if (resp.ret_code !== 200) {
                    mc.erro(resp.ret_msg_detail);
                    return;
                };

                if (resp.ret_value.isEnabledBtnPolicyPack) {
                    setIsDisable(false);
                } else {
                    setIsDisable(true);
                }

            })
            .catch((error) => {
                mc.error(`There was an error while fetching your data: ${handleEnablePolicyPack.name}\n` + error);
                console.error('fitPostSummary - Error:', error);
            });
    };

    async function handleSummary() {
        useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
                if (data.ret_code !== 200) {
                    mc.error(data.ret_msg_details);
                    return;
                }
                setSummary({
                    typeOfCover: data.ret_value.typeOfCover,
                    client: data.ret_value.client,
                    obligorCoding: data.ret_value.obligorCoding,
                    responseBy: data.ret_value.responseBy,
                    internalContact: data.ret_value.internalContact,
                    broker: data.ret_value.broker,
                    dealCode: data.ret_value.deal,
                    nmFacility: data.ret_value.nmFacility,
                    nmObligor: data.ret_value.nmObligor,
                    projectName: data.ret_value.projectName,
                });
            })
            .catch((error) => {
                mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
                console.error('fitPostSummary - Error:', error);
            });
    };

    async function handlePolicyPack() {
        loading.start();
        fitinsur.setAuthToken(authContext.token);
        fitinsur.createPolicyPack(props.match.params.idOperation)
            .then(resp => resp.json())
            .then(data => {
                if (data.ret_code !== 200) {
                    mc.error(data.ret_msg_details);
                    return;
                }

                loading.stop();
                history.push(`/broking/send-approval-pack/${props.match.params.idOperation}`)
            })
            .catch((error) => {
                mc.error(error);
                console.error('fitPostReject - Error:', error);
                loading.stop();
            });
    }

    function handleDialog() {
        setDialog({
            visible: true,
            title: "LOST DEAL",
            icon: "TimesCircle",
            args: null,
        })
        requestLostDealList();
    };

    function handleRmvAttach(index) {
        loading.start();
        setAttachments(attachments.filter(tag => attachments.indexOf(tag) !== index));

        const idDocument = attachments[index].idDocument

        fitinsur.setAuthToken(authContext.token);
        fitinsur.requestWordingDelete(props.match.params.idOperation, idDocument)
            .then(data => data.json())
            .then(resp => {
                if (resp.ret_code !== 200) {
                    mc.error(resp.ret_msg_details);
                    loading.stop();
                    return;
                } else {
                    handleGetFiles();
                    handleEnablePolicyPack();
                    loading.stop();
                }
            })
            .catch(err => {
                mc.error("An error happened, please try again");
                loading.stop();
            });
            setTimeout(() =>  handleEnablePolicyPack(), 4000);
            handleEnablePolicyPack();
    };

    async function handleImport(file) {
        const formData = new FormData();

        formData.append('fileDocument', file)
        formData.append('idOperation', props.match.params.idOperation)

        fitinsur.setAuthToken(authContext.token);
        fitinsur.requestWordingUpload(formData)
            .then(x => x.json())
            .then(res => {
                if (res.ret_code !== 200) {
                    mc.error(res.ret_msg_details);
                    loading.stop();
                    return;
                }
                console.log("HANDLE IMPORT", res);
            })
            .then(() => {
                handleEnablePolicyPack();
                handleGetFiles()
            })
            .catch(err => {
                mc.error("An error happened, please try again");
                loading.stop();
            });
            setTimeout(() =>  handleEnablePolicyPack(), 4000);
            handleEnablePolicyPack();
    };

    function handleBack() {
        history.goBack();
    };

    function handleMktCompostion() {
        history.push(`/broking/market-composition/${props.match.params.idOperation}`)
    };

    useEffect(() => {
        fitinsur.setAuthToken(authContext.token);

        handleGetFiles();
        handleModal();
        handleSummary();
        handleEnablePolicyPack();
    }, [])

    return (
        <Layout idOperation={props.match?.params?.idOperation} title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"} subtitle={summary.dealCode ? summary.dealCode : "Deal Code"}>
              <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} /> 

            <Scrollbox>

                <BrokingSummary data={summary ? summary : ''} />

                <ContentCard title="Generate Wording" icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>

                    <DialogComponent
                        icon={dialog.icon}
                        title={dialog.title}
                        
                        show={dialog.visible}
                        setDialog={setDialog}
                    >
                        <Formik
                            initialValues={{ reasons: "" }}
                            onSubmit={(e) => HandleLostSubmit(e, lostDeal.array, dialog.args)}
                        >
                            <Form>
                                <DialogSelect>
                                    <Field
                                        name="reasons"
                                        placeholder="Select the reason the deal was lost"
                                        component={SelectField}
                                        options={lostDeal.formated}
                                    />
                                </DialogSelect>

                                <DialogCancel
                                    onClick={() => {
                                        setDialog({
                                            visible: false,
                                            title: null,
                                            icon: null,
                                            args: null,
                                        });
                                    }}
                                >
                                    Cancel
                                </DialogCancel>
                                <DialogConfirm type="submit">Confirm</DialogConfirm>
                            </Form>
                        </Formik>
                    </DialogComponent>

                    <FileModal idOperation={props?.match?.params?.idOperation} file={file} />
                    <Row >
                        {(!attachments || !attachments.length) && <Col md={3}>
                            <ButtonContainer>
                                <PlaceHolder htmlFor="fileInput" >UPLOAD FILE</PlaceHolder>
                                <TagInput
                                    id="fileInput"
                                    type="file"
                                    multiple={false}
                                    onChange={(event) => handleImport(event.target.files[0])}
                                />
                            </ButtonContainer>
                        </Col>}
                        <Col md={6} style={{ marginTop: "15px" }}>
                            <TagList2
                                tags={attachments}
                                disableType
                                hideTrash={false}
                                removeTag={(index) => handleRmvAttach(index)}
                            />
                        </Col>
                    </Row>
                    <ButtonContainer>
                        <Button forth onClick={() => handleBack()}>&lt; Back</Button>
                        <RenderButtons idOperation={props.match?.params?.idOperation}>
                            <ButtonContent>
                                <div style={{ marginTop: "5px" }}>
                                    <Button secundary onClick={() => handleDialog()}>LOST</Button>
                                </div>
                                <HasPermission permission={props.permissions.MARKETING_COMPOSITION}>
                                    <Button third style={{ marginLeft: "10px", marginTop: "5px" }} onClick={() => handleMktCompostion()}>
                                        CDR
                                    </Button>
                                </HasPermission>
                                <HasPermission permission={props.permissions.GENERATE_MRC}>
                                    <Button primary style={{ marginLeft: "10px", marginTop: "5px" }} onClick={() => handlePolicyPack()} disabled={isDisable || !attachments.length}>
                                        POLICY PACK
                                    </Button>
                                </HasPermission>
                            </ButtonContent>
                        </RenderButtons>
                    </ButtonContainer>
                </ContentCard>
            </Scrollbox>
            {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
        </Layout >
    )
}
